import React from 'react';
import { FadeIn } from './ui';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  name: 'Ricardo M.',
  location: 'Houston, TX',
  text: 'Pasé de tomar 4 RedBulls al día a levantarme antes que mi alarma. Mi esposa dice que mi humor cambió totalmente. ¡Gracias LLOYD!',
  result: 'Energía estable en 7 días.'
}, {
  name: 'Carmen J.',
  location: 'Los Angeles, CA',
  text: "Como madre soltera en California, el cansancio era mi sombra. Con el protocolo de 5 min, el 'brain fog' desapareció. ¡Por fin rindo en mi negocio!",
  result: 'Claridad mental y mejor sueño.'
}];
export function Testimonials() {
  return <section className="py-24 px-4 bg-brand-dark relative" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        <FadeIn data-id="element-161">
          <h2 className="font-bebas text-4xl md:text-6xl text-center text-white mb-16" data-id="element-162">
            Ellos ya recuperaron su{' '}
            <span className="text-brand-gold" data-id="element-163">energía</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-164">
          {reviews.map((review, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-165">
              <div className="bg-brand-card p-8 rounded-2xl border border-white/10 relative" data-id="element-166">
                <Quote className="absolute top-6 right-6 w-12 h-12 text-white/5" data-id="element-167" />
                <div className="flex gap-1 mb-6" data-id="element-168">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-169" />)}
                </div>
                <p className="text-lg text-zinc-300 mb-8 italic relative z-10" data-id="element-170">
                  "{review.text}"
                </p>
                <div className="border-t border-white/10 pt-6" data-id="element-171">
                  <p className="font-bold text-white" data-id="element-172">{review.name}</p>
                  <p className="text-sm text-zinc-500 mb-2" data-id="element-173">
                    {review.location}
                  </p>
                  <p className="text-sm font-medium text-brand-orange bg-brand-orange/10 inline-block px-3 py-1 rounded-full" data-id="element-174">
                    Resultado: {review.result}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}